export default __webpack_public_path__ + "static/media/player-stop-circle.1c801352.svg";